import AppNavigate from './AppNavigate';
import PrivateRoute from './private-route';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Login from '../pages/auth/login/index';
import MainLanding from '../pages/mainLanding/Landing/MainLanding';
import Book from '../pages/mainLanding/booking/Book';
import Dashboard from '../pages/dashboard/Dashboard';
import UmbsInventoryGrid from '../pages/umb/umbsInventoryGrid/UmbsInventoryGrid';
import UserUmbrellaInventory from '../pages/umb/umbs/userUmbrellaInventory/UserUmbrellaInventory';
import Product from '../pages/product/Product';
import TableDetailsGrid from '../pages/tables/tableDetailsGrid/TableDetailsGrid';
import OrderDetailsGrid from '../pages/order/order/OrderDetailsGrid';
import UsersDetailsGrid from '../pages/users/UsersDetailsGrid';
import EmployeeInvoices from '../pages/invoices/EmployeeInvoices';
import SubjectsPage from '../pages/invoices/SubjectsPage';
import InvoiceOwnerIssues from '../pages/invoices/InvoiceOwnerIssues';
import RolesDetailsGrid from '../pages/roles/RolesDetailsGrid';
import RoleActionsPage from '../pages/roles/RoleActionsPage';
import StockDetailsGrid from '../pages/order/stock/StockDetailsGrid';
import KitchenView from '../pages/kitchen/kitchenView/kitchenView';
import Umbs from '../pages/umb/umbs/Umbs';
import Area from '../pages/umb/area/Area';
import InvoicesDetailsGrid from '../pages/invoices/InvoicesDetailsGrid';
import { NotificationProvider } from '../pages/mainLanding/Landing/NotificationContext';
import Printers from '../pages/printers/Printers';
import CompanyPage from '../pages/company/CompanyPage';
import IntegrationPage from '../pages/integration/IntegrationPage';
import AdminProductMenuDetails from '../pages/menuRestaurant/AdminProductMenuDetails';
import PublicProductMenuDetails from '../pages/menuRestaurant/PublicProductMenuDetails';
import Currencies from '../pages/currencies/Currencies';
import MyUnpaidInvoices from '../pages/invoices/MyUnpaidInvoices';
import HotelPricing from '../pages/hotel/HotelPricing/HotelPricing';
import Restaurant from '../pages/restaurant/Restaurant';
import RestaurantConfiguration from '../pages/restaurant/RestaurantConfiguration';
// import RoomDetails from '../pages/hotel/roomDetails/RoomDetails';
import Rooms from '../pages/hotel/Rooms/Rooms';
import Hotel from '../pages/hotel/Hotel/Hotel';
import RoomTypes from '../pages/hotel/RoomTypes/RoomTypes';
import HotelCalendarPage from '../pages/hotel/HotelCalendarPage/HotelCalendarPage';
import HotelDashboard from '../pages/hotel/HotelDashboard/HotelDashboard';
import BookingRequests from '../pages/hotel/BookingRequests/BookingRequests';
import BookingChannelPage from '../pages/hotel/BookingChannelPage/BookingChannelPage';
import RoomHandoverPage from '../pages/hotel/RoomHandoverPage/RoomHandoverPage';
import RoomAvailabilityWrapper from '../pages/hotel/public/RoomAvailabilityWrapper';
import OnlineReservationHotels from '../pages/hotel/public/OnlineReservationHotels';
import LoggerGrid from '../pages/logger/LoggerGrid';
import NotificationsGrid from '../pages/notifications/NotificationsGrid';
import NotificationCategoriesGrid from '../pages/notifications/NotificationCategoriesGrid';
import NotificationUserCategoriesGrid from '../pages/notifications/NotificationUserCategoriesGrid';
import PublicUserMonitor from '../pages/userMonitor/PublicUserMonitor';
import PublicUserActivation from '../pages/userMonitor/PublicUserActivation';
import CompanyEmailNotificationPage from '../pages/companyEmailNotification/CompanyEmailNotificationPage';
import UserProfile from '../pages/profile/UserProfile';
import CompanyBalance from '../pages/companyBalance/CompanyBalance';

import Expenses from '../pages/expenses/Expenses';
import ExpenseCategories from '../pages/expenses/ExpenseCategories';

import DailyInventoryCloseGrid from '../pages/dailyInventoryClose/DailyInventoryCloseGrid';
import DailyInventoryGrid from '../pages/dailyInventory/DailyInventoryGrid';
import UmbReservationsPage from '../pages/umb/umbReservations/UmbReservationsPage';
import Playgrounds from '../pages/playgrounds/Playgrounds';
import UserPlaygroundInventory from '../pages/playgrounds/UserPlaygroundInventory';

const App = () => {
  return (
    <NotificationProvider>
      <BrowserRouter>
        <AppNavigate />
        <Routes>
          <Route path="/menu/:menuKeyCode" element={<PublicProductMenuDetails />} />
          <Route
            index
            element={
              <PrivateRoute isPageLogin>
                <MainLanding />
              </PrivateRoute>
            }
          />
          <Route
            path="/book"
            element={
              <PrivateRoute isPageLogin>
                <Book />
              </PrivateRoute>
            }
          />
          <Route
            path="/login"
            element={
              <PrivateRoute isPageLogin>
                <Login />
              </PrivateRoute>
            }
          />
          <Route
            path="/register"
            element={<Navigate to="/login?register=true" replace />}
          />
          <Route
            path="/Invoices"
            element={
              <PrivateRoute routepath="Invoices">
                <InvoicesDetailsGrid />
              </PrivateRoute>
            }
          />

          <Route
            path="user-invoice"
            element={
              <PrivateRoute routepath="user-invoice">
                <MyUnpaidInvoices />
              </PrivateRoute>
            }
          />
          <Route path="/dashboard" element={<Navigate to="/dashboard-restaurant" replace />} />
          <Route
            path="/dashboard-restaurant"
            element={
              <PrivateRoute routepath="dashboard">
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/notifications"
            element={
              <PrivateRoute routepath="notifications">
                <NotificationsGrid />
              </PrivateRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <PrivateRoute skipMenuAccess>
                <UserProfile />
              </PrivateRoute>
            }
          />
          <Route
            path="/notification-categories"
            element={
              <PrivateRoute routepath="notification-categories">
                <NotificationCategoriesGrid />
              </PrivateRoute>
            }
          />
          <Route
            path="/notification-user-categories"
            element={
              <PrivateRoute routepath="notification-user-categories">
                <NotificationUserCategoriesGrid />
              </PrivateRoute>
            }
          />
          <Route
            path="/umbs"
            element={
              <PrivateRoute routepath="umbs">
                <Umbs />
              </PrivateRoute>
            }
          />
          <Route
            path="/umb-reservations"
            element={
              <PrivateRoute routepath="umbs">
                <UmbReservationsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/umbDetails"
            element={
              <PrivateRoute routepath="umbDetails">
                <UmbsInventoryGrid />
              </PrivateRoute>
            }
          />
          <Route
            path="/area"
            element={
              <PrivateRoute routepath="area">
                <Area />
              </PrivateRoute>
            }
          />
          <Route
            path="/playground"
            element={
              <PrivateRoute routepath="playground">
                <Playgrounds />
              </PrivateRoute>
            }
          />
      
          <Route
            path="/userplaygroundinventory"
            element={
              <PrivateRoute routepath="playground">
                <UserPlaygroundInventory />
              </PrivateRoute>
            }
          />
          <Route
            path="/users"
            element={
              <PrivateRoute routepath="users">
                <UsersDetailsGrid />
              </PrivateRoute>
            }
          />
          <Route
            path="/invoice-managment"
            element={
              <PrivateRoute routepath="invoice-managment">
                <EmployeeInvoices />
              </PrivateRoute>
            }
          />
          <Route
            path="/company-balance"
            element={
              <PrivateRoute routepath="company-balance">
                <CompanyBalance />
              </PrivateRoute>
            }
          />
          <Route

            path="/expenses"
            element={
              <PrivateRoute routepath=" ">
                <Expenses />
              </PrivateRoute>
            }
          />
          <Route
            path="/daily-inventory-close-grid"
            element={
              <PrivateRoute routepath="daily-inventory-close">
                <DailyInventoryCloseGrid />
              </PrivateRoute>
            }
          />
          <Route
            path="/daily-inventory"
            element={
              <PrivateRoute routepath="daily-inventory">
                <DailyInventoryGrid />
              </PrivateRoute>
            }
          />
          <Route
            path="/expense-categories"
            element={
              <PrivateRoute routepath="expense-categories">
                <ExpenseCategories />
              </PrivateRoute>
            }
          />

          <Route
           path="/invoice-subjects"
            element={
              <PrivateRoute routepath="invoice-subjects">
                <SubjectsPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/invoice-owner-issues"
            element={
              <PrivateRoute routepath="invoice-owner-issues">
                <InvoiceOwnerIssues />
              </PrivateRoute>
            }
          />

          <Route
            path="/roles"
            element={
              <PrivateRoute routepath="roles">
                <RolesDetailsGrid />
              </PrivateRoute>
            }
          />
          <Route
            path="/role-actions"
            element={
              <PrivateRoute routepath="roles">
                <RoleActionsPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/menu-details"
            element={
              <PrivateRoute routepath="menu-details">
                <AdminProductMenuDetails />
              </PrivateRoute>
            }
          />
          <Route
            path="/company"
            element={
              <PrivateRoute routepath="company">
                <CompanyPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/companyemailnotification"
            element={
              <PrivateRoute routepath="companyEmailNotification">
                <CompanyEmailNotificationPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/integration"
            element={
              <PrivateRoute routepath="integration">
                <IntegrationPage />
              </PrivateRoute>
            }
          />

          <Route
            path="/currencies"
            element={
              <PrivateRoute routepath="currencies">
                <Currencies />
              </PrivateRoute>
            }
          />

          {/* <Route
            path="/umbInventory"
            element={
              <PrivateRoute routepath="umbInventory">
                <UserUmbrellaInventory />
              </PrivateRoute>
            }
          /> */}
          <Route
            path="/userUmbInventory"
            element={
              <PrivateRoute routepath="userUmbInventory">
                <UserUmbrellaInventory />
              </PrivateRoute>
            }
          />
          <Route
            path="/kitchen"
            element={
              <PrivateRoute routepath="kitchen">
                <KitchenView />
              </PrivateRoute>
            }
          />

          <Route
            path="/restaurant"
            element={
              <PrivateRoute routepath="restaurant">
                <Restaurant />
              </PrivateRoute>
            }
          />
          <Route
            path="/restaurant-map"
            element={
              <PrivateRoute routepath="restaurant-map">
                <Restaurant />
              </PrivateRoute>
            }
          />
          <Route
            path="/restaurantConfiguration"
            element={
              <PrivateRoute routepath="company">
                <RestaurantConfiguration />
              </PrivateRoute>
            }
          />
          <Route
            path="/tableDetails"
            element={
              <PrivateRoute routepath="tableDetails">
                <TableDetailsGrid />
              </PrivateRoute>
            }
          />
          <Route
            path="/tables"
            element={
              <PrivateRoute routepath="tables">
                <TableDetailsGrid />
              </PrivateRoute>
            }
          />

          <Route
            path="/product"
            element={
              <PrivateRoute routepath="product">
                <Product />
              </PrivateRoute>
            }
          />
          <Route
            path="/orderDetails"
            element={
              <PrivateRoute routepath="orderDetails">
                <OrderDetailsGrid />
              </PrivateRoute>
            }
          />
          <Route
            path="/stockDetails"
            element={
              <PrivateRoute routepath="stockDetails">
                <StockDetailsGrid />
              </PrivateRoute>
            }
          />

          <Route
            path="/printers"
            element={
              <PrivateRoute routepath="printers">
                <Printers />
              </PrivateRoute>
            }
          />
          <Route
            path="/hotelPricing"
            element={
              <PrivateRoute routepath="hotelPricing">
                <HotelPricing />
              </PrivateRoute>
            }
          />

          <Route
            path="/hotel-dashboard"
            element={
              <PrivateRoute routepath="hotelInfo">
                <HotelDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/hotel"
            element={
              <PrivateRoute routepath="hotelInfo">
                <Hotel />
              </PrivateRoute>
            }
          />

          <Route
            path="/rooms"
            element={
              <PrivateRoute routepath="hotelRooms">
                <Rooms />
              </PrivateRoute>
            }
          />

          <Route
            path="/roomtypes"
            element={
              <PrivateRoute routepath="hotelRoomTypes">
                <RoomTypes />
              </PrivateRoute>
            }
          />
          <Route
            path="/reservation"
            element={
              <PrivateRoute routepath="reservation">
                <HotelCalendarPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/bookingRequest"
            element={
              <PrivateRoute routepath="bookingRequest">
                <BookingRequests />
              </PrivateRoute>
            }
          />
          <Route
            path="/booking-channel"
            element={
              <PrivateRoute routepath="bookingChannel">
                <BookingChannelPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/room-handover"
            element={
              <PrivateRoute routepath="roomhandover">
                <RoomHandoverPage />
              </PrivateRoute>
            }
          />
          {/* <Route
            path="/booking-requests"
            element={
              <PrivateRoute routepath="bookingRequest">
                <BookingRequests />
              </PrivateRoute>
            }
          /> */}

          <Route path="/reservations/:hotelName" element={<RoomAvailabilityWrapper />} />
          <Route path="/booking" element={<OnlineReservationHotels />} />
          <Route
            path="/home"
            element={
              <PrivateRoute routepath="home">
                <PublicUserMonitor />
              </PrivateRoute>
            }
          />
          <Route
            path="/booking-monitor"
            element={
              <PrivateRoute routepath="home">
                <PublicUserMonitor />
              </PrivateRoute>
            }
          />
          <Route
            path="/booking-login"
            element={
              <PrivateRoute routepath="home">
                <PublicUserMonitor />
              </PrivateRoute>
            }
          />
          <Route path="/activate-account" element={<PublicUserActivation />} />
          <Route
            path="/logs"
            element={
              <PrivateRoute routepath="logs">
                <LoggerGrid />
              </PrivateRoute>
            }
          />
        </Routes>
      </BrowserRouter>
    </NotificationProvider>
  );
};

export default App;
